const firebaseConfig = {
    apiKey: "AIzaSyDLhWmMFO1KJe8kyU28XpMnbwsD0bmiCNg",
    authDomain: "haydar-medical-center.firebaseapp.com",
    projectId: "haydar-medical-center",
    storageBucket: "haydar-medical-center.appspot.com",
    messagingSenderId: "695325716379",
    appId: "1:695325716379:web:b007d1acbb56e7a9fd3b3e"
};

export default firebaseConfig;